<template>

  <div class="listMultiSelect">

    <div class="list-container">
      <div class="title">
        <span v-html="bankTitle"></span>
        <Tooltip :text="bankTooltip"/>
      </div>
      <div class="bank">
        <div class="search">
          <svgicon src="/icon/search.svg" height="15" width="15"/>
          <input type="search" v-model="bankFilter" :placeholder="$t('search') + '...'">
        </div>
        <div class="item"
             v-for="(item, indexItem) in bank"
             v-if="!isSelected(item) && passFiltering(item, bankFilter)"
             :key="indexItem"
             :class="{highlight: item.selected}"
             @click="toggleSelection(item)">
          <span class="name">
            <svgicon :src="item.selected ? 'icon/circle-check.svg' : 'icon/circle.svg'" :height="12" :width="12"></svgicon>
            {{formatName(item)}}
          </span>
        </div>
      </div>
      <div class="bank-actions" v-if="(showSelectAll || showUnselectAll) && $store.getters.loggedUserHasModifyPermission">
        <button class="btn btn-primary" @click="selectAllFromBank" v-if="showSelectAll && bank.length > 0">{{$t('select_all')}}</button>
        <div v-if="!showSelectAll">&nbsp;</div>
        <button class="btn btn-primary" @click="unselectAllFromBank" v-if="showUnselectAll && bank.length > 0">{{$t('unselect_all')}}</button>
      </div>
    </div>

    <div class="actions">
        <div class="swapToBank" @click="swapToBank()">
          <svgicon src="/icon/arrow.svg" height="20" width="20"/>
        </div>
        <div class="swapToSelected" @click="swapToSelected()">
          <svgicon src="/icon/arrow.svg" height="20" width="20"/>
        </div>
    </div>

    <div class="list-container">
      <div class="title">
        <span>{{selectedTitle}}</span>
        <Tooltip :text="selectedTooltip"/>
      </div>
      <div class="selected">
        <div class="search">
          <svgicon src="/icon/search.svg" height="15" width="15"/>
          <input type="search" v-model="selectedFilter" :placeholder="$t('search') + '...'">
        </div>
        <div class="item"
             v-for="(item, indexItem) in selected"
             v-if="passFiltering(item, selectedFilter)"
             :key="indexItem"
             :class="{highlight: item.selected}"
             @click="toggleSelection(item)">
          <span class="name">
            <svgicon :src="item.selected ? 'icon/circle-check.svg' : 'icon/circle.svg'" :height="12" :width="12"></svgicon>
            {{formatName(item)}}
          </span>
        </div>
      </div>
      <div class="selected-actions" v-if="(showSelectAll || showUnselectAll) && $store.getters.loggedUserHasModifyPermission">
        <button class="btn btn-primary" @click="selectAllFromSelected" v-if="showSelectAll && selected.length > 0">{{$t('select_all')}}</button>
        <div v-if="!showSelectAll">&nbsp;</div>
        <button class="btn btn-primary" @click="unselectAllFromSelected" v-if="showUnselectAll && selected.length > 0">{{$t('unselect_all')}}</button>
      </div>
    </div>

  </div>

</template>

<script>

  import Vue from "vue";
  import Tooltip from "@/components/tools/Tooltip";

  export default {

    name: "ListMultiSelect",

    components: { Tooltip },

    props: {
      bank: Array,
      bankTitle: String,
      bankTooltip: String,
      selected: Array,
      selectedTitle: String,
      selectedTooltip: String,
      showSelectAll: Boolean,
      showUnselectAll: Boolean,
      comparisonKey: String
    },

    data() {
      return {
        bankFilter: null,
        selectedFilter: null,
      }
    },

    computed: {
      locale() {
        return this.$ts.state.locale;
      },
      isSelected() {
        return item => {
          if (this.comparisonKey) {
            return this.selected.map(e => e[this.comparisonKey]).indexOf(item[this.comparisonKey]) !== -1;
          }
          return this.selected.indexOf(item) !== -1;
        }
      }
    },

    methods: {
      swapToBank() {
        let i = this.selected.length;
        while (i--) {
          let item = this.selected[i];
          if (item.selected) {
            item.selected = false;
            this.selected.splice(i,1);
          }
        }
        this.$emit("changed");
      },
      swapToSelected() {
        let i = this.bank.length;
        while (i--) {
          let item = this.bank[i];
          if (item.selected && this.selected.indexOf(item) === -1) {
            item.selected = false;
            this.selected.push(item);
          }
        }
        this.$emit("changed");
      },
      toggleSelection(item) {
        Vue.set(item, "selected", !item.selected);
        this.$forceUpdate();
      },
      selectAllFromBank() {
        for (let item of this.bank) {
          if (this.selected.indexOf(item) === -1 && this.passFiltering(item, this.bankFilter)) {
            item.selected = true;
          }
        }
        this.$forceUpdate();
      },
      selectAllFromSelected() {
        for (let item of this.selected) {
          if (this.passFiltering(item, this.selectedFilter)) {
            item.selected = true;
          }
        }
        this.$forceUpdate();
      },
      unselectAllFromBank() {
        for (let item of this.bank) {
          item.selected = false;
        }
        this.$forceUpdate();
      },
      unselectAllFromSelected() {
        for (let item of this.selected) {
          item.selected = false;
        }
        this.$forceUpdate();
      },
      passFiltering(item, filter) {
        if (!item) { return false; }
        filter = filter ? filter.trim().toLowerCase() : null;
        let filtered = item.name || item.description || '';
        return !filter
            || (typeof filtered === 'object' && Object.values(item.name).some(e => e && e.toLowerCase().includes(filter)))
            || (typeof filtered === 'string' && item.name.toLowerCase().includes(filter))
            || (typeof item.note === 'string' && item.note.toLowerCase().includes(filter))
      },
      formatName(item) {
        if (typeof item.name === "string" && !item.name.fr && !item.name.en) {
          return item.name;
        }
        let name = translateObject(item.name || item.description);
        let note = item.note ? ` (${item.note})` : "";
        return name + note;
      }
    }
  };

</script>

<style lang="scss" scoped>

  .listMultiSelect {
    display: flex;
    background-color: white;

    &.disabled {
      .actions, .item {
        pointer-events: none !important;
        cursor: not-allowed;
      }
    }
  }
  .list-container {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    width: 100%;

    & > .title {
      display: flex;
      justify-content: space-between;
      margin-bottom: 5px;
      color: #808080;
      font-size: 14px;
      align-items: center;

      .tooltip {
        margin-left: 4px;
      }
    }
  }
  .bank, .selected {
    flex-grow: 1;
    flex-shrink: 0;
    background-color: white;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    padding: 10px;
    height: 240px;
    overflow-y: scroll;
    cursor: pointer;
  }
  .swapToBank,.swapToSelected {
    width: 40px;
    height: 40px;
    display: flex;
    flex-shrink: 0;
    align-items:center;
    justify-content:center;
    background-color: #f5f5f5;
    border-radius: 5px;
    fill: var(--primary-color);
    margin: 5px 20px;
    cursor: pointer;
  }
  .swapToBank {
    .svgicon {
      transform: rotateZ(90deg);
    }
  }
  .swapToSelected {
    .svgicon {
      transform: rotateZ(-90deg);
    }
  }
  .actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .item {
    padding: 5px 0;
    cursor: pointer;
    .name {
      display: block;
      background-color: #e6e6e6;
      width: 100%;
      padding: 6px 8px;
      border-radius: 14px;
      font-size: 14px;
      line-height: 1.2;
      display: flex;
      align-items: center;
      fill: #bfbfbf;
      .svgicon {
        margin-right: 8px;
      }
    }
    &.highlight .name {
      background-color: var(--primary-color);
      color: white;
      fill: white;
    }
  }
  .search {
    fill: #d9d9d9;
    position: relative;

    .svgicon {
      position: absolute;
      right: 0;
      top: 5px;
      background-color: white;
    }

    input[type=search] {
      border: none;
      border-bottom: 1px solid #d9d9d9;
      width: 100%;
      margin-bottom: 10px;
      padding-bottom: 10px;
    }
  }

  .bank-actions, .selected-actions {
    display: flex;
    justify-content: space-between;
    padding: 10px;

    .btn {
      padding: 4px 10px;
      font-size: 14px;
      background-color: #e6e6e6;
      color: var(--primary-color);
    }
  }

  @media (max-width: 767px) {
    .swapToBank, .swapToSelected {
      margin: 5px 10px;
    }
    .item .name {
      font-size: 13px;
    }
  }

</style>
